import { Box, Container } from '@mui/material';
import { ILayoutProps } from '@/types/layout';
import { useFlowState } from '@/components/AppState';
import useIsSeekerEnrollment2 from '@/components/hooks/useIsSeekerEnrollment2';
import { FLOWS } from '@/constants';
import { SxClassProps } from '@/types/common';
import { ServiceType } from '@/__generated__/globalTypes';

const getClasses = (isWideSpacingLayout: boolean): SxClassProps => ({
  root: (theme) => ({
    maxWidth: '100%',
    px: isWideSpacingLayout ? theme.spacing(3) : 2,
    py: theme.spacing(3),
    overflowX: 'hidden',
    boxSizing: 'border-box',
    flex: '1 0 auto',
    [theme.breakpoints.up('md')]: {
      py: theme.spacing(6),
    },
  }),
  content: {
    margin: 'auto',
    maxWidth: '410px',
  },
});

function DefaultLayout({ children }: ILayoutProps) {
  const { flowName } = useFlowState();
  const { isSeekerEnrollment2Eligible: isSeekerEnrollment2EligibleSC } = useIsSeekerEnrollment2(
    ServiceType.SENIOR_CARE
  );

  /* istanbul ignore next */
  const isWideSpacingLayout =
    flowName === (FLOWS.SEEKER_IN_FACILITY.name && !isSeekerEnrollment2EligibleSC) ||
    flowName === FLOWS.SEEKER.name ||
    flowName === FLOWS.LTCG.name;

  const classes = getClasses(isWideSpacingLayout);

  return (
    <Container sx={classes.root}>
      <Box component="div" sx={classes.content}>
        {children}
      </Box>
    </Container>
  );
}

export default DefaultLayout;
